import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { pure } from 'recompose';
import { stylesColors as colors } from 'angieslist-styles';
import { CheckmarkIcon, WarningIcon } from '@angi/icons';
import type { Element } from 'react';
import type { ProfileCompletionReducerState } from '../../common/profileReducer';

export type Props = {
   serviceProviderProfile: ProfileCompletionReducerState,
   sectionName: string,
};

const ProfileIndicatorComponent = ({ sectionName, serviceProviderProfile } : Props) :Element<"div"> => {
  const profileCompletion = serviceProviderProfile.getProfileCompletion;
  if (!profileCompletion.isLoading && profileCompletion.response) {
    const { response } = profileCompletion;
    const section = response[sectionName];
    if (section && section.complete) {
      return <CheckmarkIcon style={{ width: '35px', fill: colors.stateSuccessColor }} />;
    } else if (section.alert) {
      return <WarningIcon style={{ width: '29px', fill: colors.buttonPrimaryDefault }} />;
    }
  }

  return (
    null
  );
};

export default (compose(
  connect(state => ({
    serviceProviderProfile: state.serviceProviderProfile,
  })),
  pure,
)(ProfileIndicatorComponent): any);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ProfileIndicator.js